import React from 'react';
import IntakeConfig from '../../../interfaces/IntakeConfig.interface';
import BackButton from '../form/BackButton';
import MainButton from '../form/MainButton';
import PlanFormBuilder from '../plan/PlanFormBuilder';
import PricePlanView from '../plan/PricePlanView';

const BusinessPlanSection = ({ config, onBack }: { config: IntakeConfig, onBack: () => void }) => {
  return (
    <>
      <BackButton onClick={onBack}>Back</BackButton>
      {
        config.plans
          ? (
            <>
              <PricePlanView plans={config.plans} />
              <MainButton type="submit">Continue</MainButton>
            </>
          )
          : null
      }
      {
        config.plan
          ? (
            <PlanFormBuilder config={config}>
              <MainButton type="submit">Continue</MainButton>
            </PlanFormBuilder>
          )
          : null
      }
    </>
  );
};

export default BusinessPlanSection;
